// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ih-7";
export var emphasizeQuantity = "_ih-3";
export var flatBottomCorners = "_ih-5";
export var productImage = "_ih-0";
export var quantityContainer = "_ih-2";
export var quantityHeader = "_ih-6";
export var tooltip = "_ih-1";
export var wrapAndEllipsesOverflow = "_ih-4";